class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.initOptionsListeners();
  }

  initOptionsListeners() {
    this.querySelector('input[type="radio"][checked]')?.click();
    this.querySelectorAll('input[type="radio"]').forEach((radio, i, arr) => {
      radio.addEventListener("change", (e) => {
        const ELM_target = e.target;
        const variantId = ELM_target.value;
        const variantTitle = ELM_target.getAttribute("data-custom-variant-title");
        const variantAvailable = ELM_target.getAttribute("data-variant-available");
        arr.forEach((radio) => {
          if (radio !== ELM_target) {
            radio.removeAttribute("checked");
          }
        });
        ELM_target.checked = true;
        ELM_target.setAttribute("checked", "");
        document.dispatchEvent(
          new CustomEvent("variantChange", {
            detail: {
              variantId,
              variantTitle,
              variantAvailable,
            },
          })
        );
      });
    });
  }
}

customElements.define("variant-radios", VariantRadios);
class VariantTabs extends VariantRadios {
  ELM_categoriesSizeLabels;
  ELM_categoriesSizeValues;

  constructor() {
    super();
    this.ELM_categoriesSizeLabels = this.querySelectorAll("[data-tab-heading]");
    this.ELM_categoriesSizeValues = this.querySelectorAll("[data-tab-content-value]");
    this.init();
    this.handleAddEventListeners();
    this.handleObserveProductLaunch();
  }

  handleObserveProductLaunch() {
    const isProductLaunch = document.querySelector(".main-product.product-launch");
    let counter = 0;
    if (isProductLaunch) {
      const myIntervalFn = setInterval(() => {
        counter++;
        const productLaunch = document.querySelector(".main-product.product-launch");
        const rafflrStatus = productLaunch.getAttribute("rafflr-status");

        if (rafflrStatus) {
          if (rafflrStatus === "completed") {
            // Product launch completed, disable all radio buttons
            this.querySelectorAll('input[type="radio"]').forEach((radio) => radio.classList.add("radio--unavailable"));
          }
          // Product launch must be in progress, leave all radio buttons and stop checking
          clearInterval(myIntervalFn);
        } else if (counter > 20) {
          // Timeout: attribute never appeared, disable as fallback
          this.querySelectorAll('input[type="radio"]').forEach((radio) => radio.classList.add("radio--unavailable"));
          clearInterval(myIntervalFn);
        }
      }, 1000);
    }
  }

  init() {
    const counts = {};

    this.querySelectorAll("[data-tab-content-value]").forEach((item) => {
      const currentKey = item.getAttribute("data-tab-content-value");
      const currentCount = counts[currentKey] || 0;
      counts[currentKey] = currentCount + 1;
    });

    Object.keys(counts).forEach((key) => {
      if (counts[key] > 1) {
        this.querySelectorAll(`[data-tab-content-value="${key}"]`).forEach((item, index) => {
          if (index > 0) {
            item.remove();
          }
        });
      }
    });

    this.classList.add("variant-tabs-innitialized");
  }

  handleAddEventListeners() {
    this.ELM_categoriesSizeLabels.forEach((ELM_categorySizeLabel) => {
      ELM_categorySizeLabel.addEventListener("click", (e) => this.handleCategorySizeLabelClick(e.target));
    });
  }

  handleCategorySizeLabelClick(elm) {
    const ELM_target = elm;
    const value = ELM_target.getAttribute("data-tab-heading"); //value can be US, USW, CM, MM ...

    // Create regex patterns for both prefix and suffix cases (case-insensitive)
    const prefixRegex = new RegExp(`^${value}(\\d+\\s*[⅓⅔]?|\\d*\\.\\d+)$`, 'i'); // regex for US7.5, USW7.5, ... (categorySize + number)
    const suffixRegex = new RegExp(`^(\\d+\\s*[⅓⅔]?|\\d*\\.\\d+)${value}$`, 'i'); // regex for 50CM, 400MM, ... (number + categorySize)

    this.querySelectorAll(`[data-tab-content-value]`).forEach((ELM_categorySizeValue) => {
      const dataValue = ELM_categorySizeValue.getAttribute("data-tab-content-value");
      // dataValues can be US7.5, 50CM, 400MM, ...
      const matchesPrefix = dataValue.match(prefixRegex);
      const matchesSuffix = dataValue.match(suffixRegex);
      ELM_categorySizeValue.classList.toggle("hidden", !(matchesPrefix || matchesSuffix));
    });

    const ELM_currentSelectedCategorySizeLabel = this.querySelector("[data-tab-heading].selected");
    ELM_currentSelectedCategorySizeLabel?.classList.remove("selected");
    ELM_target.classList.add("selected");
    document.dispatchEvent(
      new CustomEvent("categorySizeChange", {
        detail: { categorySize: value },
      })
    );
  }
}

customElements.define("variant-tabs", VariantTabs);
